<!-- requests/inturn -->
<template>
  <RequestsTableRedesigned
    :api-url-props="'/v2/requests?in_turn=true'"
    title="In Turn Requests"
  />
</template>

<script>

import RequestsTableRedesigned from './RequestsTableRedesigned.vue'

export default {
  components: {
    RequestsTableRedesigned,
  },

}
</script>
